/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPcLaptopIcon32Regular = forwardRef('TechPcLaptopIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 3a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h16a5 5 0 0 0 5-5V8a5 5 0 0 0-5-5H8ZM5 8a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V8Z" }),
        React.createElement("path", { d: "M4.84 24.63a1 1 0 0 0-1.553-1.26l-2.075 2.553C-.116 27.557 1.047 30 3.152 30h25.696c2.105 0 3.268-2.443 1.94-4.077l-2.075-2.554a1 1 0 0 0-1.553 1.262l2.076 2.554a.5.5 0 0 1-.388.815H3.152a.5.5 0 0 1-.388-.815L4.84 24.63Z" })));
});
